import styled from 'styled-components';

import { FontAwesomeIcon, IconDefinition } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { Color } from 'style/types';

const Container = styled(Horizontal).attrs({ gap: 0, center: true })`
  height: var(--triple-unit);
  width: var(--quadruple-unit);
  background-color: var(--background-color, var(--c-nd-900));
  border-radius: var(--half-unit);

  &.xs {
    height: 18px;
    width: 18px;
  }
`;

export type Props = {
  size?: 'xs' | 'lg';
  backgroundColor?: Color;
  icon: IconDefinition;
  color?: Color;
};

export const PaymentMethodIcon = ({
  size = 'lg',
  backgroundColor = 'var(--c-white)',
  icon,
  color = 'var(--c-black)',
}: Props) => {
  return (
    <Container
      className={size}
      style={
        {
          '--background-color': backgroundColor,
        } as React.CSSProperties
      }
    >
      <FontAwesomeIcon size={size} icon={icon} color={color} />
    </Container>
  );
};
